import { FC } from "react";
import { Column } from "react-table";
import { useGetCompanyCustomersQuery } from "services/admin/adminUserApi";
import { ICustomerCompany } from "common/models/user/ICustomerCompany";
import { SkeletonTable } from "common/components/Table/SkeletonTable";
import { QueryLayout } from "common/components/Layout/QueryLayout";
import { Table } from "common/components/Table/Table";
import { getQueryDateParam, timeFormatter } from "common/utils/helpers";
import { NotFoundTitle } from "common/components/Title/NotFoundTitle";

export const CustomerCompanyTable: FC<{
  query?: string;
  dateFrom?: string;
  dateTo?: string;
}> = ({ query, dateFrom, dateTo }) => {
  const {
    data: users,
    isLoading,
    isFetching,
    error,
  } = useGetCompanyCustomersQuery({
    query,
    date_from: getQueryDateParam(dateFrom),
    date_to: getQueryDateParam(dateTo),
  });

  return (
    <QueryLayout
      isLoading={isLoading}
      error={error}
      skeleton={<SkeletonTable rowCount={6} colCount={columns.length} />}
    >
      {users?.length ? (
        <Table data={users} columns={columns} isLoading={isFetching} />
      ) : (
        <NotFoundTitle />
      )}
    </QueryLayout>
  );
};

const columns: Column<ICustomerCompany>[] = [
  {
    Header: "#",
    accessor: "id",
  },
  {
    Header: "ФИО основателя",
    accessor: "founder",
    Cell: ({ row }: any) => (
      <span>
        {`${row.original.founder.last_name} ${row.values.founder.first_name} ${row.original.founder.middle_name}`}
      </span>
    ),
  },
  {
    Header: "Название организации",
    accessor: "name",
  },
  {
    Header: "Дата регистрации",
    accessor: "created_at",
    Cell: ({ row }: any) => (
      <>
        {timeFormatter({
          time: new Date(row.values.created_at),
          mode: "dd-MM-yyyy",
        })}
      </>
    ),
  },
  {
    Header: "Завершённые заказы",
    accessor: "finished_orders_count",
  },
  {
    Header: "Сумма, руб.",
    accessor: "orders_sum",
  },
  {
    Header: "Баланс, руб.",
    accessor: "balance",
    Cell: ({ row }: any) => (
      <span
        className={`${row.values.balance > 0 ? "text-primary" : "text-red"}`}
      >
        {row.values.balance.toFixed(2)}
      </span>
    ),
  },
  {
    Header: "Споры",
    accessor: "disputes_count",
  },
];
